import React from 'react';
import { cn } from '../lib/utils';
import { useTheme } from '../contexts/ThemeContext';
import { useTableUiTheme } from '../contexts/TableUiThemeContext';

/**
 * Toggle between legacy (classic) and refined table UI presets.
 * Persists to localStorage key `tableUiTheme`.
 */
const TableUiThemeSwitcher = ({ className, fullWidth = false }) => {
  const { theme } = useTheme();
  const { themeId, themeIds, themes, setTableUiTheme } = useTableUiTheme();

  return (
    <div
      className={cn(
        'flex items-center rounded-lg border p-0.5',
        fullWidth && 'w-full',
        theme.border.light,
        theme.colors.background,
        className
      )}
      role="group"
      aria-label="Table appearance"
    >
      {themeIds.map((id) => {
        const preset = themes[id];
        const active = themeId === id;
        return (
          <button
            key={id}
            type="button"
            onClick={() => setTableUiTheme(id)}
            title={preset.description}
            className={cn(
              'px-2.5 py-1 text-xs font-medium rounded-md transition-colors',
              fullWidth && 'flex-1 text-center',
              active
                ? cn(theme.colors.primary, theme.text.inverse, theme.shadow.sm)
                : cn(theme.text.secondary, `hover:${theme.text.primary}`)
            )}
            aria-pressed={active}
          >
            {preset.labelEl || preset.label}
          </button>
        );
      })}
    </div>
  );
};

export default TableUiThemeSwitcher;
